<template>
	<header class="landing-page-header">
		<div class="container">
			<div class="grid" :class="{ 'pb-100': hasOuterSpacing }">
				<div class="col-12 col-8-md col-offset-2-md text-align-center">
					<slot>
						<h1 class="overline mb-100" :class="{ 'mt-300': hasOuterSpacing }">
							<BasePlaceHolderInline
								:placehold="isLoading"
								width="6em"
								data-test="header-title"
								:class="theme === 'dark' ? 'text-color-gray-40' : 'text-color-current-color'"
							>
								{{ header.title }}
							</BasePlaceHolderInline>
						</h1>
						<BasePlaceHolder :placehold="isLoading" :line-count="5">
							<h2
								:class="[
									'heading-1 mb-150',
									theme === 'dark' ? 'text-color-white' : 'text-color-current-color'
								]"
								data-test="header-heading"
								v-html="deorphanText(header.heading)"
							>
							</h2>
							<p
								v-for="(summary, summaryId) in header.summary"
								:key="summaryId"
								:class="[
									{
										'body-xl': isSecondary,
										'text-color-white': theme === 'dark',
										'text-color-content-secondary': theme === 'light'
									}
								]"
								:data-test="`header-summary-${summaryId}`"
								v-html="deorphanText(summary)"
							></p>
						</BasePlaceHolder>
					</slot>
				</div>
			</div>
		</div>
	</header>
</template>

<script setup lang="ts">
import { deorphanText } from '@filters/shared-filters';
import { LandingPageHeader } from 'types/layout';

interface Props {
	header: LandingPageHeader;
	isLoading?: boolean;
	theme?: string;
	isSecondary?: boolean;
	hasOuterSpacing?: boolean;
}

withDefaults(defineProps<Props>(), {
	isLoading: false,
	theme: 'light',
	isSecondary: false,
	hasOuterSpacing: true
});
</script>
